<script lang="ts">
  import Row from "./Row.svelte";
  import type { DataRow } from "./types";

  export let data: DataRow[];

  let selectedRow: number = 0;

  $: maxValue = data.reduce(
    (acc: number, curr: DataRow) => (acc > curr.value ? acc : curr.value),
    0
  );

  $: console.log(data);

  const selectRow = (idx: number) => {
    selectedRow = idx;
  };
  const percentDelta = (val: number, baseline: number) =>
    Math.round(((val - baseline) / baseline) * 100);
</script>

<style>
  .main-container {
    height: 100%;
  }
  .graph-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    max-height: 20em;
    overflow-y: auto;
    padding-right: 2em;
  }
</style>

<main class="main-container">
  <div class="graph-container">
    {#each data as dataRow, idx}
      <Row
        isFocused={selectedRow === idx}
        showDetails={selectedRow === idx}
        onClick={() => selectRow(idx)}
        {maxValue}
        dataLabel={dataRow.label}
        dataPoint={dataRow.value}
        averageDeltaPercent={dataRow.averageValue !== undefined ? percentDelta(dataRow.value, dataRow.averageValue) : null}
        dataPointAverage={dataRow.averageValue !== undefined ? dataRow.averageValue : null}
        subsectionLabels={dataRow.subLabels ? dataRow.subLabels : null} />
    {/each}
  </div>
</main>
